import React from 'react'

interface Props {
  green?: boolean
}

function MarkerIcon(props: Props) {
  const { green } = props
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <rect
        fill={green ? '#3DEABF' : '#3B8DED'}
        width="48"
        height="48"
        x="0"
        y="0"
        rx="10"
      />
      <path
        fill={green ? '#093769' : '#fff'}
        d="M23.885 16c3.19 0 5.784 2.594 5.784 5.783 0 3.19-2.594 5.783-5.784 5.783h-3.109v5.046c0 .766-.622 1.388-1.388 1.388C18.62 34 18 33.378 18 32.612V16h5.885zm0 2.776h-3.109v6.014h3.11c1.658 0 3.007-1.349 3.007-3.007 0-1.66-1.349-3.007-3.008-3.007z"
      />
    </svg>
  )
}

export default MarkerIcon
